export default __webpack_public_path__ + "static/media/aboutbanner.2635a491.png";